// extracted by mini-css-extract-plugin
export default {"scope":"Yz7vq","list":"VhtDQ","item":"B-C9Y"};